export type Locale = 'en' | 'sk' | 'ua';

export type Dict = Record<string, string>;

export const I18N: Record<Locale, Dict> = {
  en: {
    'nav.features': 'Features',
    'nav.how': 'How it works',
    'nav.clubs': 'Clubs',
    'nav.faq': 'FAQ',
    'nav.cta': 'Get the app',
    'hero.eyebrow': 'Social events · clubs · meetups',
    'hero.h1': 'Find your people.<br/><span class="grad-text">Gather</span> them up.',
    'hero.lead':
      "A warm little home for the things you'd actually want to do — personalized events nearby, clubs that match your taste, and the friends you'll make along the way.",
    'hero.cta1': 'Download Gather',
    'hero.cta2': 'See how it works',
    'hero.meta': 'people gathering this week',
    'hero.bglabel': 'hero photo · drop in lifestyle image (blurred)',
    'chip.a.t': 'New event near you',
    'chip.a.s': 'Sunset rooftop · 0.4 km',
    'chip.b.t': 'Mia joined your event',
    'chip.b.s': '+2 friends also going',
    'app.greet.s': 'Thursday · Košice',
    'app.greet.t': 'Hey Alex,<br/>3 events for you today',
    'app.tag.1': 'Rooftop',
    'app.tag.2': 'Music',
    'app.ribbon': 'Limited',
    'app.event.club': 'Golden Hour Club',
    'app.event.title': 'Sunset vinyl rooftop',
    'app.event.meta': 'Hosted by Mia · Tonight, 7pm',
    'app.cc.1': 'Film Club',
    'app.cc.2': 'Sunrise 5k',
    'app.cc.3': 'Ceramics',
    'app.club.name': 'Sunday Runners',
    'app.club.members': 'Members',
    'app.club.events': 'Events',
    'app.club.join': 'Join',
    'feat.eyebrow': "What's inside",
    'feat.h2': 'Built around <span class="grad-text">the things you\'d<br/>actually do.</span>',
    'feat.sub':
      "Five features, one quiet idea: make it easier to say yes to a friend, a plan, a tuesday that could've gone either way.",
    'feat.1.num': '01 / Personalized feed',
    'feat.1.h': 'A feed that actually knows you.',
    'feat.1.p':
      "Tell Gather what you're into once. From then on, every event surfaced is something you'd genuinely show up for — sorted by proximity, timing, and who's already going.",
    'feat.2.num': '02 / Clubs',
    'feat.2.h': 'Find your club.<br/>Or start one.',
    'feat.2.p':
      'From Sunday runners to ceramic dabblers — clubs gather the regulars so recurring events plan themselves.',
    'feat.3.num': '03 / Chat',
    'feat.3.h': 'Stay in the loop.',
    'feat.3.p':
      "Every event gets a pre-lobby and live chat. Who's bringing what, where to meet, who's running late.",
    'feat.4.num': '04 / Posts',
    'feat.4.h': 'Share the after.',
    'feat.4.p': 'Photos, reactions, comments — the good stuff that usually disappears into a group chat.',
    'feat.5.num': '05 / Create',
    'feat.5.h': 'Host in 60 seconds.',
    'feat.5.p': 'A title, a time, a place. We handle the invites, RSVPs, attachments, and reminders.',
    'shots.eyebrow': 'A peek inside',
    'shots.h2': 'Every screen, thoughtfully warm.',
    'shots.sub':
      "Glass surfaces, soft gradients, and room to breathe — wherever you land in Gather, it should feel like walking into a party where someone's already saved you a seat.",
    'how.eyebrow': 'How it works',
    'how.h2': 'Three small steps. One loud yes.',
    'how.1.h': 'Tell us what you love.',
    'how.1.p': 'Pick a few interests — ceramics to climbing, poetry to padel. It takes a minute.',
    'how.2.h': 'Browse your warm feed.',
    'how.2.p': 'Events and clubs show up tuned to you — hyperlocal, timed right, with friendly faces.',
    'how.3.h': 'Show up. Stay.',
    'how.3.p': "Join, chat, post the after. Come back next week — there's always something on.",
    'cta.eyebrow': 'Free · iOS & Android',
    'cta.h': 'Your next favorite<br/>Tuesday is one tap away.',
    'cta.p':
      "Download Gather and discover what's happening around you this week. No algorithmic rabbit hole. Just people, places, and plans you'll actually keep.",
    'cta.qr': 'SCAN TO INSTALL',
    'store.apple.top': 'Download on the',
    'store.apple.main': 'App Store',
    'store.google.top': 'Get it on',
    'store.google.main': 'Google Play',
    'get.redirecting': 'Opening the App Store…',
    'get.redirecting.android': 'Opening Google Play…',
    'get.redirecting.sub': "If nothing happens, tap the button below.",
    'get.desktop.h': 'Open this on your phone',
    'get.desktop.p': 'Scan the QR or open this page on your phone to grab Gather. Available on iOS and Android.',
    'privacy.eyebrow': 'Privacy & contact',
    'privacy.h': 'Privacy policy',
    'privacy.intro': 'This page tells you who runs Gather, what data we handle, and how to reach us about your privacy rights.',
    'privacy.controller.h': 'Data controller',
    'privacy.controller.p': 'The person responsible for processing your personal data is:',
    'privacy.field.name': 'Name',
    'privacy.field.address': 'Address',
    'privacy.field.email': 'Email',
    'privacy.field.phone': 'Phone',
    'privacy.collect.h': 'What we collect',
    'privacy.collect.p': 'Account details (name, email, profile photo), events you create or join, posts and chat messages, and basic usage data needed to keep the app running. We use Apple and Google sign-in if you choose them, and verify your email with a one-time code.',
    'privacy.use.h': 'How we use it',
    'privacy.use.p': 'To run your account, show you relevant events and clubs, deliver notifications you opt into, and keep the platform safe. We do not sell your data.',
    'privacy.rights.h': 'Your rights',
    'privacy.rights.p': 'Under GDPR you can ask for a copy of your data, correct it, delete it, or stop us from processing it. Email us and we will get back to you within 30 days.',
    'privacy.contact.h': 'Contact',
    'privacy.contact.p': 'Questions, requests, or anything else — write to',
    'privacy.full.h': 'Full privacy policy',
    'privacy.full.p': "Below is the same policy we ship inside the mobile app. If the embed doesn't load,",
    'privacy.full.open': 'open it in a new tab',
    'terms.eyebrow': 'Terms of Service',
    'community.eyebrow': 'Community Rules',
    'news.eyebrow': 'Changelog · What\'s new',
    'news.h': "What's new",
    'news.intro':
      'Releases, big features, and the small touches we shipped along the way. Newest first.',
    'news.new': "What's new",
    'news.fixes': 'Fixes & improvements',
    'news.loadMore': 'Load more',
    'news.loading': 'Loading…',
    'news.end': "That's everything so far. More on the way.",
    'mq.eyebrow': 'Happening now',
    'mq.h': 'Real events, every week',
    'mq.view': 'View',
    'mq.full': 'Full',
    'mq.placeLeft': '1 place left',
    'mq.placesLeft': '{n} places left',
    'band.eyebrow': 'Real nights, real people',
    'band.h':
      'The best plans start<br/>with <span class="grad-text">someone saying yes.</span>',
    'band.sub':
      "Concerts, run clubs, dinners, pickup games — whatever your thing is, there's a room for it near you tonight.",
    'faq.eyebrow': 'FAQ',
    'faq.h': 'Good questions<br/>we hear a lot.',
    'faq.sub':
      'Still curious? Drop us a line at <a style="color:var(--purple-600);font-weight:600" href="mailto:gather.community.org@gmail.com">gather.community.org@gmail.com</a> — real humans, fast replies.',
    'faq.1.q': 'Is Gather free?',
    'faq.1.a':
      'Yes — discovering, joining, and hosting events is completely free. Some premium clubs may charge their own entry, handled in-app.',
    'faq.2.q': 'Where can I use Gather?',
    'faq.2.a':
      'Anywhere. You can create or join events in any city. The feed is hyperlocal — it tunes to wherever you are. The more people in your area use Gather, the richer it gets.',
    'faq.3.q': 'Do I need to know anyone to start?',
    'faq.3.a':
      'Nope. Most events happen in small groups of strangers-turning-friends. Hosts are verified, chats are moderated, and you can leave any time.',
    'faq.4.q': 'Can I host a private event for a club only?',
    'faq.4.a': 'Yes. Every event has visibility controls — public, club-only, or invite-only with a shareable link.',
    'faq.5.q': 'Is my location data shared?',
    'faq.5.a':
      'Only your city, and only to personalize your feed. Exact location is never broadcast to other users. You can turn it off entirely in Settings.',
    'faq.6.q': 'Is Gather on iOS and Android?',
    'faq.6.a': 'Yes — Gather is live on both. Download it from the App Store (iOS 16+) or Google Play. Same app, same features on every device.',
    'faq.7.q': 'How do I delete my account and my data?',
    'faq.7.a':
          'Open <strong>Settings → Delete Account</strong> inside the app, or use our <a style="color:var(--purple-600);font-weight:600" href="/delete-account">account deletion page</a> if you no longer have the app installed. We complete deletion within 30 days.',
    'foot.product': 'Product',
    'foot.company': 'Company',
    'foot.legal': 'Legal',
    'foot.tagline': "A warm little home for the things you'd actually want to do. Made with care in Bratislava.",
  },
  sk: {
    'nav.features': 'Funkcie',
    'nav.how': 'Ako to funguje',
    'nav.clubs': 'Kluby',
    'nav.faq': 'Časté otázky',
    'nav.cta': 'Stiahnuť appku',
    'hero.eyebrow': 'Spoločenské akcie · kluby · stretnutia',
    'hero.h1': 'Nájdi svojich ľudí.<br/><span class="grad-text">Zhromaždi</span> ich.',
    'hero.lead':
      'Útulný domov pre veci, na ktoré naozaj chceš ísť — personalizované akcie v okolí, kluby podľa tvojej chuti a ľudia, s ktorými si cestou sadneš.',
    'hero.cta1': 'Stiahnuť Gather',
    'hero.cta2': 'Ako to funguje',
    'hero.meta': 'ľudí sa tento týždeň stretáva',
    'hero.bglabel': 'hero foto · vlož lifestyle obrázok (rozmazaný)',
    'chip.a.t': 'Nová akcia blízko teba',
    'chip.a.s': 'Strešná terasa · 0,4 km',
    'chip.b.t': 'Mia sa pripojila',
    'chip.b.s': '+2 kamaráti tiež idú',
    'app.greet.s': 'Štvrtok · Košice',
    'app.greet.t': 'Ahoj Alex,<br/>3 akcie pre teba dnes',
    'app.tag.1': 'Terasa',
    'app.tag.2': 'Hudba',
    'app.ribbon': 'Limit',
    'app.event.club': 'Golden Hour Club',
    'app.event.title': 'Vinylový západ slnka',
    'app.event.meta': 'Organizuje Mia · Dnes, 19:00',
    'app.cc.1': 'Filmový klub',
    'app.cc.2': 'Sunrise 5k',
    'app.cc.3': 'Keramika',
    'app.club.name': 'Nedeľní bežci',
    'app.club.members': 'Členovia',
    'app.club.events': 'Akcie',
    'app.club.join': 'Pridať sa',
    'feat.eyebrow': 'Čo je vo vnútri',
    'feat.h2': 'Postavené na <span class="grad-text">veciach, ktoré<br/>naozaj robíš.</span>',
    'feat.sub':
      'Päť funkcií, jedna tichá myšlienka: uľahčiť povedať áno kamarátovi, plánu, utorku, ktorý mohol skončiť aj inak.',
    'feat.1.num': '01 / Personalizovaný feed',
    'feat.1.h': 'Feed, ktorý ťa skutočne pozná.',
    'feat.1.p':
      'Raz povedz Gatheru, čo ťa baví. Od vtedy každá akcia, ktorú uvidíš, je niečo, na čo by si naozaj šiel — podľa blízkosti, času a toho, kto už ide.',
    'feat.2.num': '02 / Kluby',
    'feat.2.h': 'Nájdi svoj klub.<br/>Alebo ho založ.',
    'feat.2.p':
      'Od nedeľných bežcov po amatérskych keramikárov — kluby spoja pravidelných, takže sa opakujúce akcie plánujú samy.',
    'feat.3.num': '03 / Chat',
    'feat.3.h': 'Zostaň v obraze.',
    'feat.3.p': 'Každá akcia má pre-lobby a live chat. Kto čo prinesie, kde sa stretneme, kto mešká.',
    'feat.4.num': '04 / Príspevky',
    'feat.4.h': 'Zdieľaj to po akcii.',
    'feat.4.p': 'Fotky, reakcie, komentáre — veci, ktoré normálne zmiznú v skupinovom chate.',
    'feat.5.num': '05 / Vytvoriť',
    'feat.5.h': 'Hostuj za 60 sekúnd.',
    'feat.5.p': 'Názov, čas, miesto. Pozvánky, RSVP, prílohy a pripomienky vybavíme my.',
    'shots.eyebrow': 'Pohľad dovnútra',
    'shots.h2': 'Každá obrazovka, premyslene teplá.',
    'shots.sub':
      'Sklenené povrchy, jemné prechody a priestor na nádych — kdekoľvek v Gatheri pristaneš, má to byť ako vojsť do párty, kde ti už niekto zabral miesto.',
    'how.eyebrow': 'Ako to funguje',
    'how.h2': 'Tri malé kroky. Jedno hlasné áno.',
    'how.1.h': 'Povedz nám, čo máš rád.',
    'how.1.p': 'Vyber pár záľub — od keramiky po lezenie, od poézie po padel. Zaberie to minútu.',
    'how.2.h': 'Prezri si svoj feed.',
    'how.2.p': 'Akcie a kluby sa ukážu naladené na teba — lokálne, v správny čas, s priateľskými tvárami.',
    'how.3.h': 'Príď. Zostaň.',
    'how.3.p': 'Pridaj sa, čet, zdieľaj. Vráť sa o týždeň — vždy sa niečo deje.',
    'cta.eyebrow': 'Zadarmo · iOS & Android',
    'cta.h': 'Tvoj ďalší obľúbený<br/>utorok je na dosah.',
    'cta.p':
      'Stiahni si Gather a zisti, čo sa tento týždeň deje okolo teba. Žiadna algoritmická nora. Len ľudia, miesta a plány, ktoré aj dodržíš.',
    'cta.qr': 'NASKENUJ A NAINŠTALUJ',
    'store.apple.top': 'Stiahni v',
    'store.apple.main': 'App Store',
    'store.google.top': 'Získaj na',
    'store.google.main': 'Google Play',
    'get.redirecting': 'Otvárame App Store…',
    'get.redirecting.android': 'Otvárame Google Play…',
    'get.redirecting.sub': 'Ak sa nič nestane, klikni na tlačidlo nižšie.',
    'get.desktop.h': 'Otvor toto na telefóne',
    'get.desktop.p': 'Naskenuj QR alebo otvor túto stránku na telefóne, aby si si stiahol Gather. Dostupné pre iOS aj Android.',
    'privacy.eyebrow': 'Súkromie a kontakt',
    'privacy.h': 'Zásady ochrany súkromia',
    'privacy.intro': 'Táto stránka ti hovorí, kto prevádzkuje Gather, aké údaje spracúvame a ako nás kontaktovať ohľadom tvojich práv.',
    'privacy.controller.h': 'Prevádzkovateľ údajov',
    'privacy.controller.p': 'Osoba zodpovedná za spracovanie tvojich osobných údajov je:',
    'privacy.field.name': 'Meno',
    'privacy.field.address': 'Adresa',
    'privacy.field.email': 'Email',
    'privacy.field.phone': 'Telefón',
    'privacy.collect.h': 'Aké údaje zbierame',
    'privacy.collect.p': 'Údaje účtu (meno, email, profilová fotka), udalosti, ktoré vytvoríš alebo navštíviš, príspevky a chat správy a základné údaje o používaní potrebné na chod aplikácie. Používame Apple a Google prihlásenie, ak ich zvolíš, a email overujeme jednorazovým kódom.',
    'privacy.use.h': 'Ako ich používame',
    'privacy.use.p': 'Na prevádzku tvojho účtu, na zobrazovanie relevantných udalostí a klubov, na doručovanie notifikácií, ktoré si zvolíš, a na bezpečnosť platformy. Tvoje údaje nepredávame.',
    'privacy.rights.h': 'Tvoje práva',
    'privacy.rights.p': 'Podľa GDPR môžeš požiadať o kópiu svojich údajov, ich opravu, vymazanie alebo zastavenie spracovania. Napíš nám a ozveme sa do 30 dní.',
    'privacy.contact.h': 'Kontakt',
    'privacy.contact.p': 'Otázky, požiadavky alebo čokoľvek iné — napíš na',
    'privacy.full.h': 'Úplné zásady ochrany súkromia',
    'privacy.full.p': 'Nižšie je tá istá politika, akú dodávame v mobilnej aplikácii. Ak sa náhľad nenačíta,',
    'privacy.full.open': 'otvor ju v novej karte',
    'terms.eyebrow': 'Podmienky používania',
    'community.eyebrow': 'Pravidlá komunity',
    'news.eyebrow': 'Zoznam zmien · Novinky',
    'news.h': 'Novinky',
    'news.intro':
      'Vydania, veľké funkcie a drobnosti, ktoré sme cestou pridali. Najnovšie navrchu.',
    'news.new': 'Čo je nové',
    'news.fixes': 'Opravy a vylepšenia',
    'news.loadMore': 'Načítať viac',
    'news.loading': 'Načítava sa…',
    'news.end': 'To je zatiaľ všetko. Ďalšie na ceste.',
    'mq.eyebrow': 'Deje sa teraz',
    'mq.h': 'Skutočné podujatia, každý týždeň',
    'mq.view': 'Zobraziť',
    'mq.full': 'Obsadené',
    'mq.placeLeft': 'Zostáva 1 miesto',
    'mq.placesLeft': 'Zostáva {n} miesta',
    'band.eyebrow': 'Skutočné večery, skutoční ľudia',
    'band.h':
      'Najlepšie plány sa začínajú<br/>tým, že niekto <span class="grad-text">povie áno.</span>',
    'band.sub':
      'Koncerty, bežecké kluby, večere, neformálne zápasy — nech je tvoja vec čokoľvek, dnes večer sa pre ňu nájde miesto blízko teba.',
    'faq.eyebrow': 'FAQ',
    'faq.h': 'Dobré otázky,<br/>ktoré počúvame často.',
    'faq.sub':
      'Stále zvedavý? Napíš nám na <a style="color:var(--purple-600);font-weight:600" href="mailto:gather.community.org@gmail.com">gather.community.org@gmail.com</a> — odpovedajú skutoční ľudia, rýchlo.',
    'faq.1.q': 'Je Gather zadarmo?',
    'faq.1.a':
      'Áno — objavovanie, pridávanie sa aj hostenie akcií je úplne zadarmo. Niektoré prémiové kluby si môžu účtovať vlastný vstup priamo v appke.',
    'faq.2.q': 'Kde môžem Gather používať?',
    'faq.2.a': 'Kdekoľvek. Udalosti môžeš vytvárať či navštevovať v ľubovoľnom meste. Feed je hyperlokálny — naladí sa na to, kde si práve. Čím viac ľudí vo tvojom okolí Gather používa, tým je bohatší.',
    'faq.3.q': 'Musím niekoho poznať, aby som začal?',
    'faq.3.a':
      'Nie. Väčšina akcií sa deje v malých skupinkách, kde sa z neznámych stávajú kamoši. Hostí overujeme, chaty moderujeme a kedykoľvek môžeš odísť.',
    'faq.4.q': 'Môžem spraviť súkromnú akciu len pre klub?',
    'faq.4.a': 'Áno. Každá akcia má nastavenia viditeľnosti — verejná, len pre klub alebo iba na pozvánku cez zdieľaný odkaz.',
    'faq.5.q': 'Zdieľa sa moja poloha?',
    'faq.5.a':
      'Len tvoje mesto a len pre personalizáciu feedu. Presná poloha sa nikdy nevysiela ostatným. V nastaveniach ju môžeš vypnúť úplne.',
    'faq.6.q': 'Je Gather na iOS aj Androide?',
    'faq.6.a': 'Áno — Gather je dostupný na oboch. Stiahni ho z App Store (iOS 16+) alebo z Google Play. Rovnaká appka, rovnaké funkcie na každom zariadení.',
      'faq.7.q': 'Ako vymažem účet a svoje dáta?',
      'faq.7.a':
          'Otvor <strong>Nastavenia → Vymazať účet</strong> v aplikácii, alebo použi našu <a style="color:var(--purple-600);font-weight:600" href="/delete-account">stránku na vymazanie účtu</a>, ak appku už nemáš. Vymazanie dokončíme do 30 dní.',

      'foot.product': 'Produkt',
    'foot.company': 'Spoločnosť',
    'foot.legal': 'Právne',
    'foot.tagline': 'Útulný domov pre veci, na ktoré naozaj chceš ísť. Vyrobené s láskou v Bratislave.',
  },
  ua: {
    'nav.features': 'Можливості',
    'nav.how': 'Як це працює',
    'nav.clubs': 'Клуби',
    'nav.faq': 'Питання',
    'nav.cta': 'Завантажити',
    'hero.eyebrow': 'Події · клуби · зустрічі',
    'hero.h1': 'Знайди своїх.<br/><span class="grad-text">Збирай</span> їх разом.',
    'hero.lead':
      'Теплий маленький дім для справ, на які хочеться йти — персональні події поруч, клуби за твоїм смаком і друзі, яких зустрінеш дорогою.',
    'hero.cta1': 'Завантажити Gather',
    'hero.cta2': 'Як це працює',
    'hero.meta': 'людей збираються цього тижня',
    'hero.bglabel': 'герой-фото · додай lifestyle зображення (розмите)',
    'chip.a.t': 'Нова подія поруч',
    'chip.a.s': 'Дах на заході · 0,4 км',
    'chip.b.t': 'Мія приєдналася',
    'chip.b.s': '+2 друга теж ідуть',
    'app.greet.s': 'Четвер · Київ',
    'app.greet.t': 'Привіт, Алекс,<br/>3 події на сьогодні',
    'app.tag.1': 'Дах',
    'app.tag.2': 'Музика',
    'app.ribbon': 'Ліміт',
    'app.event.club': 'Клуб Золотої Години',
    'app.event.title': 'Вінілова вечірка на даху',
    'app.event.meta': 'Від Мії · Сьогодні, 19:00',
    'app.cc.1': 'Кіноклуб',
    'app.cc.2': 'Ранковий 5k',
    'app.cc.3': 'Кераміка',
    'app.club.name': 'Недільні бігуни',
    'app.club.members': 'Учасники',
    'app.club.events': 'Події',
    'app.club.join': 'Долучитись',
    'feat.eyebrow': 'Що всередині',
    'feat.h2': 'Побудовано навколо <span class="grad-text">речей, які ти<br/>реально робиш.</span>',
    'feat.sub':
      "П'ять можливостей, одна тиха ідея: зробити легшим «так» другу, плану, вівторку, який міг би бути й інакшим.",
    'feat.1.num': '01 / Персональна стрічка',
    'feat.1.h': 'Стрічка, що справді тебе знає.',
    'feat.1.p':
      'Раз скажи Gather, що тобі цікаво. Далі кожна подія у стрічці — це те, на що ти б реально пішов, відсортовано за близькістю, часом та хто вже йде.',
    'feat.2.num': '02 / Клуби',
    'feat.2.h': 'Знайди свій клуб.<br/>Або створи.',
    'feat.2.p':
      "Від недільних бігунів до любителів кераміки — клуби об'єднують постійних, тож регулярні події плануються самі.",
    'feat.3.num': '03 / Чат',
    'feat.3.h': 'Будь у курсі.',
    'feat.3.p': 'Кожна подія має pre-lobby й живий чат. Хто що приносить, де зустріч, хто запізнюється.',
    'feat.4.num': '04 / Публікації',
    'feat.4.h': 'Ділись «після».',
    'feat.4.p': 'Фото, реакції, коментарі — те хороше, що зазвичай зникає в груповому чаті.',
    'feat.5.num': '05 / Створити',
    'feat.5.h': 'Хостинг за 60 секунд.',
    'feat.5.p': 'Назва, час, місце. Запрошення, RSVP, вкладення й нагадування ми беремо на себе.',
    'shots.eyebrow': 'Погляд усередину',
    'shots.h2': 'Кожен екран — продумано теплий.',
    'shots.sub':
      "Скляні поверхні, м'які градієнти й простір для повітря — куди б ти не потрапив у Gather, відчуття має бути як зайти на вечірку, де тобі вже лишили місце.",
    'how.eyebrow': 'Як це працює',
    'how.h2': 'Три маленькі кроки. Одне гучне «так».',
    'how.1.h': 'Розкажи, що любиш.',
    'how.1.p': 'Обери кілька інтересів — від кераміки до скелелазіння, від поезії до падел. Це хвилина.',
    'how.2.h': 'Дивись свою теплу стрічку.',
    'how.2.p': 'Події й клуби підлаштовані під тебе — локально, вчасно, з дружніми обличчями.',
    'how.3.h': 'Приходь. Залишайся.',
    'how.3.p': 'Долучайся, спілкуйся, діли «після». Повертайся наступного тижня — завжди щось відбувається.',
    'cta.eyebrow': 'Безкоштовно · iOS & Android',
    'cta.h': 'Твій наступний улюблений<br/>вівторок — на один тап.',
    'cta.p':
      'Завантаж Gather і дізнайся, що відбувається навколо тебе цього тижня. Без алгоритмічної нори. Лише люди, місця й плани, які ти дотримаєш.',
    'cta.qr': 'СКАНУЙ ДЛЯ ВСТАНОВЛЕННЯ',
    'store.apple.top': 'Завантажуй в',
    'store.apple.main': 'App Store',
    'store.google.top': 'Завантажуй на',
    'store.google.main': 'Google Play',
    'get.redirecting': 'Відкриваємо App Store…',
    'get.redirecting.android': 'Відкриваємо Google Play…',
    'get.redirecting.sub': 'Якщо нічого не сталося, натисни кнопку нижче.',
    'get.desktop.h': 'Відкрий це на телефоні',
    'get.desktop.p': 'Скануй QR або відкрий цю сторінку на телефоні, щоб завантажити Gather. Доступно для iOS та Android.',
    'privacy.eyebrow': 'Приватність і контакти',
    'privacy.h': 'Політика конфіденційності',
    'privacy.intro': 'Ця сторінка розповідає, хто стоїть за Gather, які дані ми обробляємо і як зв’язатися щодо твоїх прав.',
    'privacy.controller.h': 'Контролер даних',
    'privacy.controller.p': 'Особа, відповідальна за обробку твоїх персональних даних:',
    'privacy.field.name': 'Ім’я',
    'privacy.field.address': 'Адреса',
    'privacy.field.email': 'Email',
    'privacy.field.phone': 'Телефон',
    'privacy.collect.h': 'Які дані ми збираємо',
    'privacy.collect.p': 'Дані акаунту (ім’я, email, фото профілю), події, які ти створюєш або відвідуєш, дописи й чат-повідомлення, а також базові дані про використання, потрібні для роботи застосунку. Використовуємо Apple і Google вхід, якщо ти їх обираєш, а email підтверджуємо одноразовим кодом.',
    'privacy.use.h': 'Як ми їх використовуємо',
    'privacy.use.p': 'Щоб працював твій акаунт, показувати релевантні події й клуби, надсилати сповіщення, які ти обрав, і підтримувати безпеку платформи. Ми не продаємо твої дані.',
    'privacy.rights.h': 'Твої права',
    'privacy.rights.p': 'Згідно з GDPR ти можеш запитати копію своїх даних, виправити їх, видалити або зупинити обробку. Напиши нам — відповімо протягом 30 днів.',
    'privacy.contact.h': 'Контакти',
    'privacy.contact.p': 'Питання, запити чи щось інше — пиши на',
    'privacy.full.h': 'Повна політика конфіденційності',
    'privacy.full.p': 'Нижче — та сама політика, що й у мобільному застосунку. Якщо вбудоване вікно не завантажується,',
    'privacy.full.open': 'відкрий її в новій вкладці',
    'terms.eyebrow': 'Умови користування',
    'community.eyebrow': 'Правила спільноти',
    'news.eyebrow': 'Список змін · Новинки',
    'news.h': 'Новинки',
    'news.intro':
      'Релізи, великі функції та дрібниці, які ми додавали дорогою. Найновіше зверху.',
    'news.new': 'Що нового',
    'news.fixes': 'Виправлення та покращення',
    'news.loadMore': 'Завантажити ще',
    'news.loading': 'Завантаження…',
    'news.end': 'Це поки що все. Далі — більше.',
    'mq.eyebrow': 'Зараз відбувається',
    'mq.h': 'Справжні події щотижня',
    'mq.view': 'Переглянути',
    'mq.full': 'Немає місць',
    'mq.placeLeft': 'Залишилось 1 місце',
    'mq.placesLeft': 'Залишилось {n} місця',
    'band.eyebrow': 'Справжні вечори, справжні люди',
    'band.h':
      'Найкращі плани починаються<br/>з того, що хтось <span class="grad-text">каже так.</span>',
    'band.sub':
      'Концерти, бігові клуби, вечері, аматорські матчі — що б тобі не подобалося, сьогодні ввечері поруч знайдеться місце для цього.',
    'faq.eyebrow': 'FAQ',
    'faq.h': 'Хороші запитання,<br/>які чуємо часто.',
    'faq.sub':
      'Ще цікаво? Напиши на <a style="color:var(--purple-600);font-weight:600" href="mailto:gather.community.org@gmail.com">gather.community.org@gmail.com</a> — справжні люди, швидкі відповіді.',
    'faq.1.q': 'Gather безкоштовний?',
    'faq.1.a':
      'Так — шукати, долучатись і хостити події — повністю безкоштовно. Деякі преміум-клуби можуть мати свій платний вхід, оплата в додатку.',
    'faq.2.q': 'Де можна користуватися Gather?',
    'faq.2.a': 'Будь-де. Створюй або відвідуй події в будь-якому місті. Стрічка гіперлокальна — підлаштовується під те, де ти зараз. Що більше людей навколо тебе користуються Gather, то цікавіше.',
    'faq.3.q': 'Треба когось знати, щоб почати?',
    'faq.3.a':
      'Ні. Більшість подій — це маленькі групи, де незнайомі стають друзями. Хости перевірені, чати модеруються, можна піти будь-коли.',
    'faq.4.q': 'Можу зробити приватну подію тільки для клубу?',
    'faq.4.a': 'Так. Кожна подія має налаштування видимості — публічна, лише для клубу, або тільки за запрошенням.',
    'faq.5.q': 'Чи передається моя геолокація?',
    'faq.5.a':
      'Лише місто, і лише для персоналізації стрічки. Точна локація ніколи не транслюється іншим. У налаштуваннях її можна повністю вимкнути.',
    'faq.6.q': 'Gather є на iOS та Android?',
    'faq.6.a': 'Так — Gather доступний на обох. Завантаж з App Store (iOS 16+) або Google Play. Той самий застосунок, ті самі можливості на будь-якому пристрої.',
      'faq.7.q': 'Як видалити акаунт і свої дані?',
      'faq.7.a':
          'Відкрий <strong>Налаштування → Видалити обліковий запис</strong> в додатку, або скористайся нашою <a style="color:var(--purple-600);font-weight:600" href="/delete-account">сторінкою видалення акаунту</a>, якщо додатка вже немає. Видалення завершуємо протягом 30 днів.',
      'foot.product': 'Продукт',
    'foot.company': 'Компанія',
    'foot.legal': 'Правове',
    'foot.tagline': 'Теплий маленький дім для справ, на які хочеться йти. Зроблено з любов\'ю в Братиславі.',
  },
};

export const DEFAULT_LOCALE: Locale = 'en';
export const LOCALE_STORAGE_KEY = 'gather.locale';

export const SEO_COPY: Record<Locale, { title: string; description: string; ogLocale: string; htmlLang: string }> = {
  en: {
    title: 'Gather — Find Local Events, Clubs & Meetups Near You',
    description:
      'Gather is a free social events app to discover hyperlocal events, join clubs, and meet new friends near you. Host meetups in 60 seconds. Live on iOS and Android.',
    ogLocale: 'en_US',
    htmlLang: 'en',
  },
  sk: {
    title: 'Gather — Nájdi lokálne akcie, kluby a stretnutia v okolí',
    description:
      'Gather je bezplatná aplikácia pre spoločenské akcie. Objav hyperlokálne udalosti, pridaj sa do klubov a spoznaj nových kamarátov v okolí. Hostuj akciu za 60 sekúnd.',
    ogLocale: 'sk_SK',
    htmlLang: 'sk',
  },
  ua: {
    title: 'Gather — Місцеві події, клуби та зустрічі поруч з тобою',
    description:
      'Gather — безкоштовний застосунок соціальних подій. Знаходь події поруч, приєднуйся до клубів і знайомся з друзями. Створюй зустріч за 60 секунд.',
    ogLocale: 'uk_UA',
    htmlLang: 'uk',
  },
};
